import { yupResolver } from "@hookform/resolvers/yup";
import { FunctionComponent, useEffect, useMemo } from "react";
import {
  Controller,
  ControllerRenderProps,
  FieldError,
  useForm,
} from "react-hook-form";
import { ErrorText } from "../../../../../../components/billing";
import { DateField } from "../../../../../../components/forms/date";
import { Between } from "../../../../../../store/launch-configurations/models/internal/between";
import { Field } from "../../../../../../store/launch-configurations/models/internal/field";
interface IDateCustomFieldProps {
  field: ControllerRenderProps<Field.Field<string>, "typeDetails">;
  error: FieldError | undefined;
}

const DateCustomField: FunctionComponent<IDateCustomFieldProps> = ({
  error,
  field,
}) => {
  const { control, watch } = useForm<
    Exclude<Field.Date<string>["typeDetails"], null>
  >({
    resolver: useMemo(() => yupResolver(Between.schema), []),
  });

  useEffect(() => {
    const sub = watch((data) => field.onChange(data));
    return () => sub.unsubscribe();
  }, [watch, field.onChange]);

  return (
    <div>
      <div>Min</div>
      <Controller
        control={control}
        name="between.start"
        render={({ field, fieldState: { error } }) => (
          <DateField {...field} helperText={error?.message} error={!!error} />
        )}
      />
      <div>Max</div>
      <Controller
        control={control}
        name="between.end"
        render={({ field, fieldState: { error } }) => (
          <DateField {...field} helperText={error?.message} error={!!error} />
        )}
      />
      {error ? <ErrorText>{error.message}</ErrorText> : null}
    </div>
  );
};

export default DateCustomField;
